/**
 * @see {@link https://developers.google.com/tag-platform/tag-manager/templates/consent-apis#consent-introduction | Consent Api's on developers.google.com}
 */
export enum GoogleConsentType {
  /** Required cookies for basic functionality. Mostly used to check if the user has interacted with the consent dialog. */
  REQUIRED = "required",
  /** Enables storage, such as cookies, related to advertising. */
  AD_STORAGE = "ad_storage",
  /** Sets consent for sending user data to Google for online advertising purposes. */
  AD_USER_DATA = "ad_user_data",
  /** Sets consent for personalized advertising. */
  AD_PERSONALIZATION = "ad_personalization",
  /** Enables storage, such as cookies, related to analytics (for example, visit duration). */
  ANALYTICS_STORAGE = "analytics_storage",
  /** Enables storage that supports the functionality of the website or app such as language settings. */
  FUNCTIONALITY_STORAGE = "functionality_storage",
  /** Enables storage related to personalization such as video recommendations. */
  PERSONALIZATION_STORAGE = "personalization_storage",
  /** Enables storage related to security such as authentication functionality, fraud prevention, and other user protection */
  SECURITY_STORAGE = "security_storage",
}
